// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { DefaultPage } from '.';
import { DefaultPageTrain } from '.';

export default {
  path: '',
  name: 'Pb service list',
  childRoutes: [
    // { path: 'es/pasajes-bus', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'bus/:originOnward/:destOnward/:journeyDateOnward',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path: 'bus/:originOnward/:destOnward/:journeyDateOnward/:journeyDateReturn',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path: 'bus/:originOnward/:destOnward/:journeyDateOnward/:journeyDateReturn/:tripStep',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path:
        'bus/:serviceIdOnward/:originIdOnward/:destIdOnward/:journeyDateOnward/:journeyDateReturn/:boardingStageOnward/:droppingStageOnward/:selectedSeatsOnward/:tripStep',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },

    // { path: 'es/pasajes-bus', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'es/pasajes-bus/:originOnward/:destOnward/:journeyDateOnward',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path: 'es/pasajes-bus/:originOnward/:destOnward/:journeyDateOnward/:journeyDateReturn',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path:
        'es/pasajes-bus/:originOnward/:destOnward/:journeyDateOnward/:journeyDateReturn/:tripStep',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path:
        'es/pasajes-bus/:serviceIdOnward/:originIdOnward/:destIdOnward/:journeyDateOnward/:journeyDateReturn/:boardingStageOnward/:droppingStageOnward/:selectedSeatsOnward/:tripStep',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },

    // { path: 'en/bus-tickets', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'en/bus-tickets/:originOnward/:destOnward/:journeyDateOnward',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path: 'en/bus-tickets/:originOnward/:destOnward/:journeyDateOnward/:journeyDateReturn',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path:
        'en/bus-tickets/:originOnward/:destOnward/:journeyDateOnward/:journeyDateReturn/:tripStep',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },
    {
      path:
        'en/bus-tickets/:serviceIdOnward/:originIdOnward/:destIdOnward/:journeyDateOnward/:journeyDateReturn/:boardingStageOnward/:droppingStageOnward/:selectedSeatsOnward/:tripStep',
      name: 'Default page',
      component: DefaultPage,
      isIndex: false,
    },

    // { path: ':originOnward/:destOnward/:journeyDateOnward', name: 'Default page', component: DefaultPage, isIndex: false},
  ],
};



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/route.js